import { post, makeApiError } from "@/shared/utils/fetchApi";

export class WorkspaceLogoService {
  // A organização vem do token no backend, não do corpo da requisição.
  static async uploadWorkspaceLogo(
    file: File,
    workspaceId: string | undefined,
  ): Promise<string> {
    const formData = new FormData();
    formData.append("logo", file);

    // POST /products/:id/logo → { logo_url } flat; aceita 'new' (produto
    // ainda não existe). Org vem do row no backend, não do body.

    const r = await post<{ logo_url?: string }>(
      `/products/${workspaceId || "new"}/logo`,
      formData,
      { headers: {}, parseJson: true },
    );
    if (!r?.logo_url) {
      throw makeApiError("Logo upload returned no URL", {
        code: "E_UNEXPECTED_RESPONSE",
      });
    }
    return r.logo_url;
  }
}
